const uploadKycNotificationSettings = {
  hideUploadKycNotification: true
};

export default class BillingInvoiceService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    Upload,
    utils,
    userSettingsService
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.Upload = Upload;
    this.utils = utils;
    this.userSettingsService = userSettingsService;
  }

  exportCreditCardTransactionInvoice(accountId, transactionRefId) {
    return this.$http.post(this.#serviceBaseUrl(accountId, transactionRefId));
  }

  getStatusExportCreditCardInvoice(accountId, jobId) {
    return this.$http.get(this.#serviceBaseUrl(accountId, jobId));
  }

  exportMonthlyBillingInvoice(accountId, year, month) {
    const url = `${this.#serviceMonthlyBillingBaseUrl(accountId)}/${year}/${month}`;
    return this.$http.get(url);
  }

  getStatusExportMonthlyBillingInvoice(accountId, jobId) {
    const url = this.#serviceMonthlyBillingBaseUrl(accountId, jobId);
    return this.$http.get(url);
  }

  getAvailableInvoicesByMonth(accountId) {
    const url = this.#serviceMonthlyBillingBaseUrl(accountId, 'availableMonths');
    return this.$http.get(url);
  }

  getPricingPlan(accountId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/pricing`;
    return this.$http.get(url);
  }

  getBillingPlan(accountId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing`;
    return this.$http.get(url);
  }

  addAccountBalance(accountId, data) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/Balance`;
    return this.$http.post(url, data);
  }

  updateBillingSettings (accountId, billingSettings) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/BillingSettings`;
    return this.$http.put(url, billingSettings);
  }

  getCCTransactions(accountId, pastDays, days, pastMonths, months) {
    let params;
    if (pastMonths && months) {
      params = { pastMonths: pastMonths, months: months };
    } else if (pastDays && days) {
      params = { pastDays: pastDays, days: days };
    } else {
      params = { pastMonths: 36, months: 37};
    }
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CCTransactions`;
    return this.$http.get(url, { params: params });
  }
  getCreditCards(accountId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CreditCards`;
    return this.$http.get(url);
  }

  addCreditCard(accountId, data) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CreditCards`;
    return this.$http.post(url, data);
  }

  async deleteCreditCard(accountId, creditCardId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CreditCards/${creditCardId}`;
    const response = await this.$http.delete(url);
    // _checkCardVerified function checks whether we need to show the upload KYC details again
    this._checkCardVerified(response.data.creditCards);
    return response;
  }

  updateCreditCard(accountId, data, creditCardId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CreditCards/${creditCardId}`;
    return this.$http.put(url, data);
  }

  async verifyCreditCard(accountId, kycFiles, creditCardId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/billing/CreditCards/${creditCardId}/verify`;

    const response = await this.Upload.upload({
      url: url,
      method: 'PUT',
      data: {
        file: kycFiles
      }
    });
    this.setUploadKycNotificationSettings(true);
    return response;
  }

  setUploadKycNotificationSettings(hide) {
    return this.userSettingsService.getUserSettings().then((userSettings) => {
      userSettings.creditCardVerification = userSettings.creditCardVerification || {};
      userSettings.creditCardVerification.hideUploadKycNotification = hide;
      uploadKycNotificationSettings.hideUploadKycNotification = hide;
      return this.userSettingsService.saveUserSettings(userSettings);
    });
  }

  _checkCardVerified(cards) {
    if(cards.length > 0){
      const verifiedCardExists = _.some(cards, (card) => {
        return card.status === 'Approved' || card.status === 'ApprovalPending';
      });
      this.setUploadKycNotificationSettings(verifiedCardExists);
    } else {
      //no cards so dont show warning
      this.setUploadKycNotificationSettings(true);
    }
  }

  #serviceBaseUrl(accountId, transactionId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/billing/CCTransactions/Invoice' + (transactionId ? '/' + transactionId : '');
  }

  #serviceMonthlyBillingBaseUrl(accountId, transactionId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/invoice' + (transactionId ? '/' + transactionId : '');
  }
}
